import {
  ActionIcon,
  Button,
  Group,
  Menu,
  Tooltip,
  useMantineTheme,
} from '@mantine/core';
import {
  IconArrowLeft,
  IconChevronDown,
  IconEdit,
  IconX,
} from '@tabler/icons-react';
import React, { MouseEventHandler } from 'react';

export interface ClaimModalPreviousButtonProps {
  computedColorScheme: string;
  isLoading: boolean;
  handleOnClick: MouseEventHandler<HTMLButtonElement>; // previous navigation
  onEditShared: () => void; // jump directly to shared step
  disabled?: boolean;
  buttonText?: string;
  onCancel: () => void;
}

export const ClaimModalPreviousButton: React.FC<
  ClaimModalPreviousButtonProps
> = ({
  computedColorScheme,
  isLoading,
  handleOnClick,
  onEditShared,
  disabled = false,
  buttonText = 'Previous',
  onCancel,
}) => {
  const theme = useMantineTheme();

  return (
    <Group wrap="nowrap" gap={0}>
      <Tooltip disabled={!disabled} label={disabled ? 'Cannot go back' : ''}>
        <Button
          variant="outline"
          color="gray"
          c={computedColorScheme === 'dark' ? 'gray.0' : 'black'}
          onClick={handleOnClick}
          style={{ borderTopRightRadius: 2, borderBottomRightRadius: 2 }}
          leftSection={<IconArrowLeft size={16} />}
          loading={isLoading}
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </Tooltip>
      <Menu
        transitionProps={{ transition: 'pop' }}
        position="bottom"
        withinPortal
      >
        <Menu.Target>
          <ActionIcon
            variant="outline"
            color="gray"
            c="gray"
            disabled={disabled}
            size={36}
            style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}
          >
            <IconChevronDown
              size={16}
              stroke={1.5}
              color={theme.colors.gray[6]}
            />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={
              <IconEdit size={16} stroke={1.5} color={theme.colors.blue[5]} />
            }
            onClick={onEditShared}
          >
            Return to Shared Step
          </Menu.Item>

          <Menu.Item
            leftSection={
              <IconX size={16} stroke={1.5} color={theme.colors.red[5]} />
            }
            onClick={onCancel}
          >
            Cancel Bulk Creation
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
